import { assert } from '@ember/debug';
import { DEBUG } from '@glimmer/env';
import WeakCache from './weak-cache';

/*
 * Returns the RecordData instance associated with a given
 * Model or Identifier
 */

const RecordDataForIdentifierCache = new WeakCache(DEBUG ? 'recordData' : '');
export function setRecordDataFor(identifier, recordData) {
  assert(`Illegal set of identifier`, !RecordDataForIdentifierCache.has(identifier) || RecordDataForIdentifierCache.get(identifier) === recordData);
  RecordDataForIdentifierCache.set(identifier, recordData);
}
export function removeRecordDataFor(identifier) {
  RecordDataForIdentifierCache.delete(identifier);
}
export default function recordDataFor(instance) {
  if (RecordDataForIdentifierCache.has(instance)) {
    return RecordDataForIdentifierCache.get(instance);
  }
  return null;
}